import React from 'react';
import { useSelector } from 'react-redux';
import Router from './router';
import { isLogged as isLoggedSelector } from './store/login';

function App() {
	const isLogged = useSelector(isLoggedSelector);
	return <Router isLogged={isLogged} />;
}

export default App;
